var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adsense-container"},[_vm._v("\n  >")])
}
var staticRenderFns = []

export { render, staticRenderFns }